export default __webpack_public_path__ + "static/media/medocta-icon.3101574b.svg";